/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeprecateRequest
 */
export interface DeprecateRequest {
    /**
     * 
     * @type {string}
     * @memberof DeprecateRequest
     */
    replacementRecordId?: string;
    /**
     * 
     * @type {string}
     * @memberof DeprecateRequest
     */
    reason?: string;
}

/**
 * Check if a given object implements the DeprecateRequest interface.
 */
export function instanceOfDeprecateRequest(value: object): value is DeprecateRequest {
    return true;
}

export function DeprecateRequestFromJSON(json: any): DeprecateRequest {
    return DeprecateRequestFromJSONTyped(json, false);
}

export function DeprecateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeprecateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'replacementRecordId': json['replacementRecordId'] == null ? undefined : json['replacementRecordId'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function DeprecateRequestToJSON(json: any): DeprecateRequest {
    return DeprecateRequestToJSONTyped(json, false);
}

export function DeprecateRequestToJSONTyped(value?: DeprecateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'replacementRecordId': value['replacementRecordId'],
        'reason': value['reason'],
    };
}

